<template>
  <span style="margin-right: 5px">
    <el-button :type="type" :size="size" @click="showUploadDialog()">
      Upload
    </el-button>

    <el-dialog
      title="Upload Document"
      :visible.sync="dialogUpload"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div v-loading="loadingDocument">
        <el-upload
          class="upload-area"
          drag
          name="beneficiary_file"
          multiple
          :headers="headerUpload"
          :auto-upload="true"
          :action="actionUpload"
          :on-preview="handlePreview"
         
          :file-list="documentLists"
          :on-success="onSuccessUpload"
          
         
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
        </el-upload>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img style="width: 100%; height: auto" :src="dialogImageUrl" />
    </el-dialog>
  </span>
</template>

<script>
import { getToken } from "@/utils/auth";
import { getBeneficiaryDocument } from "@/api/beneficiary-monitor";

export default {
  components: {

  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    info: Object,
    type: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      dialogUpload: false,
      dialogImageUrl: "",
      dialogVisible: false,
      loadingDocument: false,
      actionUpload: "",
      headerUpload: {
        authorization: getToken(),
      },

      documentLists: [],
      countuploaded: 0,
    };
  },
  methods: {
    mapFileList(data) {
      if (!data) return [];
      data.forEach((element) => {
        element.url = `${
          process.env.VUE_APP_SERVER_BASE_API
        }/api/beneficiary-firewall/media/${
          element.filename
        }?token=${getToken()}`;

        element.name = element.originFilename;
      });
      return data;
    },
    showUploadDialog() {
      this.dialogUpload = true;
      this.getFileList();
    },
    getFileList() {
      this.loadingDocument = true;
      this.actionUpload = `${process.env.VUE_APP_SERVER_BASE_API}/api/beneficiary-firewall/beneficiarys/${this.uid}/documents`;
      getBeneficiaryDocument(this.uid).then(({ result, data }) => {
        this.loadingDocument = false;
        if (result) {
          this.documentLists = this.mapFileList(data);
        }
      });
    },
    onSuccessUpload(response, file, fileList) {
      if (response.result) {
        this.countuploaded++;

        if (this.countuploaded == fileList.length) {
          this.getFileList();
          this.countuploaded = 0;
        }
      } else {
        file.name = 'Upload fail - ' + file.name;
        file.status = "fail"
        this.$message({
          message: response.message,
          type: "error",
          duration: 5 * 1000,
        });
      }
    },

    fileDownload(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.originFilename;
      link.target = "_blank";
      link.click();
    },

    handlePreview(file) {
      this.fileDownload(file);
    },
    
  },
  mounted() {},
};
</script>

<style lang="scss">
.el-upload-list__item.is-fail {
    a {
      color: red;

      i{
        color: red;
      }
    }
  }
</style>